import React, { useEffect, useState } from 'react';
import { Button, ButtonGroup, Grid, IconButton, makeStyles, TextField } from '@material-ui/core';
import MUIDataTable from 'mui-datatables';
import swal from '@sweetalert/with-react';
import CssBaseline from '@material-ui/core/CssBaseline';
import AdminTopbar from './AdminTopbar';
import { Add, ArrowDropDown, ArrowDropUp } from '@material-ui/icons';
import AdminFooter from './AdminFooter';
import axiosInstance, { WEB_API } from '../common/Constants';
import DeleteIcon from '@material-ui/icons/Delete';
import { Auth } from 'aws-amplify';

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: 800,
    overflow: 'auto',
    '& .MuiPaper-root': {
      boxShadow: 'none',
      border: '1px solid rgba(224, 224, 224, 1)',
    },
    '& .MuiTableCell-root': {
      textAlign: 'center',
      fontSize: '13px',
      '& span': {
        display: 'block',
        wordBreak: 'keep-all',
      },
      '& button': {
        fontSize: '13px',
      },
    },
  },
}));

const UserListPage = (props) => {
  const classes = useStyles();
  const [data, setData] = useState();

  let cols = [
    {
      name: 'id',
      label: 'ID',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return value.replace('innon_', '');
        },
      },
    },
    {
      name: 'username',
      label: 'Name',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'id',
      label: '삭제',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <IconButton aria-label="delete" size="small" onClick={() => setDeleteAction(value, tableMeta)}>
              <DeleteIcon />
            </IconButton>
          );
        },
      },
    },
  ];

  const setDeleteAction = (value, meta) => {
    const userId = data[meta.rowIndex].id;
    if (userId === 'innon_admin') {
      swal('Admin 계정은 삭제하실수 없습니다.');
      return;
    }
    swal({
      title: '정말 삭제하시겠습니까?',
      text: '',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        axiosInstance.delete(`${WEB_API}/user/?userId=${userId}&eventId=innon`).then((data) => {
          getUserData();
        });
      }
    });
  };

  const addProject = (id, cate, title, logo) => {
    swal(
      <div>
        <h1>Admin {cate ? '수정' : '추가'}</h1>
        <p style={{ width: '100%', textAlign: 'left', marginTop: '10px' }}>ID</p>
        <TextField id={'input-id'} margin="dense" fullWidth value={title || ''} />
        <p style={{ width: '100%', textAlign: 'left', marginTop: '10px' }}>Password</p>
        <TextField id={'input-password'} type="password" margin="dense" fullWidth value={title || ''} />
        <p style={{ width: '100%', textAlign: 'left', marginTop: '10px' }}>Name</p>
        <TextField id={'input-username'} margin="dense" fullWidth value={title || ''} />
      </div>,
    ).then((isOK) => {
      if (isOK) {
        // signup
        const _id = document.getElementById('input-id').value.replace(/ /gi, '');
        let _password = document.getElementById('input-password').value.replace(/ /gi, '');
        if (('' + _password).length < 6) {
          _password = _password.padEnd(6, '0');
        }
        const _username = document.getElementById('input-username').value.replace(/ /gi, '');
        console.log('id', _id);
        console.log('password', _password);
        console.log('username', _username);
        Auth.signUp({
          username: `innon_${_id}`,
          password: _password,
          attributes: {
            email: _id + '@innon.co.kr',
            'custom:in_name': _username,
            'custom:position': 'InnoN',
            'custom:role': 'InnonAdmin',
            'custom:evt': 'innon',
          },
        }).then((user) => {
          swal('등록되었습니다.', {
            icon: 'success',
          }).then(() => {
            getUserData();
          });
        });
      }
    });
  };

  const rowClick = (_data, row) => {
    const delIdx = cols.findIndex((d) => d.name === '삭제');
    if (row.colIndex === delIdx) setDeleteAction(_data, row);
  };

  const options = {
    print: false,
    filterType: 'checkbox',
    viewColumns: false,
    download: false,
    searchOpen: false,
    selectableRows: 'none',
    onCellClick: rowClick,
  };

  const getUserData = () => {
    axiosInstance.get(`${WEB_API}/user/list?eventId=innon&limit=-1`, { headers: { Pragma: 'no-cache' } }).then((response) => {
      setData(response.data.Items);
    });
  };
  useEffect(() => {
    getUserData();
  }, []);

  return (
    <Grid item xs={12}>
      <CssBaseline />
      <AdminTopbar MIdx={3} SIdx={0} />
      <Grid container alignItems={'stretch'} direction="column" style={{ padding: 16 }} className={classes.root}>
        <Grid item>
          <Grid container spacing={4} justify={'space-between'} alignItems={'center'}>
            <Grid item>
              <h1>관리자 계정</h1>
            </Grid>
            <Grid item style={{ flex: 1 }}>
              &nbsp;
            </Grid>
            <Grid item>
              <Button variant={'outlined'} onClick={() => addProject()} startIcon={<Add />}>
                관리자 등록
              </Button>
            </Grid>
          </Grid>
        </Grid>
        <Grid item style={{ marginTop: 20 }}>
          <MUIDataTable title={''} data={data} columns={cols} options={options} />
        </Grid>
      </Grid>
      <AdminFooter />
    </Grid>
  );
};

export default UserListPage;
